export class SectorModel {
    [key: string]: string | number;
    id?: string; // SAMPLE DATA: 1,
    nombre = ''; // SAMPLE DATA: 1,
    finca = ''; // SAMPLE DATA: CLEMENT,
    m3?: string; // SAMPLE DATA: 105,
    superficie?: string; // SAMPLE DATA: 14.66,
    plantas?: string;
    cliente_nombre?: string;
    id_finca = '';
    proporcionArboles?: number;
    horas_dia_menos_45min?: number;
    tiempoPostRiego?: string;
    superficie_cultivada?: number;
    superficie_sigpac?: number;
    tiempoPreRiego?: number;
    horas_dia_text?: string;
    goteros?: string;
    caudal_gotero?: string;
    id_cliente?: string;
    id_usuario?: string;
}